module.exports = __webpack_public_path__ + "static/slogo.6ecfaf46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/slogo.svg
// module id = 1426
// module chunks = 114276838955818